import IcErrorFilledSm from '@deliveryhero/pd-cookbook/components/Icons/IcErrorFilledSm';
import IcSuccessFilledSm from '@deliveryhero/pd-cookbook/components/Icons/IcSuccessFilledSm';
import { Link } from '@deliveryhero/pd-cookbook/components/Link';
import { Tag, TagVariant } from '@deliveryhero/pd-cookbook/components/Tag';
import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';
import { Grid } from '@mui/material';

import { UserLinkStatuses, UserStates } from 'services/api';

import { LabelText } from './constants';
import { AccountLinkStatusProps } from './types';

export const AccountLinkStatus = ({
  employee,
  handleUnlink,
  handleResendInvitationEmail
}: AccountLinkStatusProps) => {
  let StatusTag, Label, Cta;

  if (employee.state === UserStates.Active) {
    if (employee.linked_status === UserLinkStatuses.Linked) {
      StatusTag = (
        <Tag
          icon={<IcSuccessFilledSm fill="tag-success-text" />}
          id={TagVariant.SUCCESS}
          label={LabelText.Status.Active}
          variant={TagVariant.SUCCESS}
        />
      );
      Label = (
        <Typography type="paragraph-sm">
          Corporate account is activated and linked to the personal account
        </Typography>
      );
      Cta = (
        <Typography type="label-md">
          <Link href="" onClick={handleUnlink}>
            {LabelText.Cta.Unlink}
          </Link>
        </Typography>
      );
    } else if (employee.linked_status === UserLinkStatuses.NotRequired) {
      StatusTag = (
        <Tag
          id={TagVariant.SUCCESS}
          variant={TagVariant.SUCCESS}
          icon={<IcSuccessFilledSm fill="tag-success-text" />}
          label={LabelText.Status.Active}
        />
      );
      Label = (
        <Typography type="paragraph-sm">
          Corporate account is activated
        </Typography>
      );
    }
  } else if (employee.state === UserStates.Invited) {
    if (employee.linked_status === UserLinkStatuses.Unlinked) {
      StatusTag = (
        <Tag
          id={TagVariant.POPULAR}
          variant={TagVariant.POPULAR}
          icon={<IcErrorFilledSm fill="popular-tag-icon" />}
          label={LabelText.Status.Invited}
        />
      );
      Label = (
        <Typography type="paragraph-sm">
          Corporate account is <b>not</b> activated and <b>not</b> linked to the
          personal account
        </Typography>
      );
      Cta = (
        <Typography type="label-md">
          <Link href="" onClick={handleResendInvitationEmail}>
            {LabelText.Cta.ResendInvite}
          </Link>
        </Typography>
      );
    } else if (employee.linked_status === UserLinkStatuses.NotRequired) {
      StatusTag = (
        <Tag
          id={TagVariant.POPULAR}
          variant={TagVariant.POPULAR}
          icon={<IcErrorFilledSm fill="popular-tag-icon" />}
          label={LabelText.Status.Invited}
        />
      );
      Label = (
        <Typography type="paragraph-sm">
          Corporate account is <b>not</b> activated
        </Typography>
      );
      Cta = (
        <Typography type="label-md">
          <Link href="" onClick={handleResendInvitationEmail}>
            {LabelText.Cta.ResendInvite}
          </Link>
        </Typography>
      );
    }
  }
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography type="title-md">Account Status</Typography>
      </Grid>
      <Grid item xs={12}>
        {StatusTag}
      </Grid>
      <Grid item xs={12}>
        {Label}
      </Grid>
      <Grid item xs={12}>
        {Cta}
      </Grid>
    </Grid>
  );
};
